module.exports = __webpack_public_path__ + "static/media/merriweather-regular-webfont.a1e02af0.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/merriweather-regular-webfont.eot
// module id = 286
// module chunks = 0